<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="cards-container">
  @for (card of cards; track card) {
    <mat-card
      class="image-card"
      [@cardAnimation]="card.animationState"
      (@cardAnimation.done)="onAnimationEnd($event, card)"
      [class.hide]="card?.image === 'src'"
    >
      <mat-card-header>
        <mat-card-title>{{ card.author }}</mat-card-title>
      </mat-card-header>
      <img [src]="card.image" [alt]="card.alt" class="behave" />
      <mat-card-footer class="centered">
        <div>{{ card.title }}</div>
      </mat-card-footer>
    </mat-card>
  }
</div>
@if ((showQrCode || noActualImages()) && checkUploadLinkString()) {
  <div class="qr-code-container">
    <div class="centered">
      <qr-code value="{{ linkToUpload }}" size="500" />
      <div>Scan and contribute!</div>
    </div>
  </div>
}
@if (noActualImages()) {
  <div class="absolute">No images to display yet.</div>
}
